import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { GridsterModule } from 'angular-gridster2';
import { CalendarModule } from 'primeng/calendar';
import { CardModule } from 'primeng/card';
import { ChartModule } from 'primeng/chart';
import { CheckboxModule } from 'primeng/checkbox';
import { DropdownModule } from 'primeng/dropdown';
import { FileUploadModule } from 'primeng/fileupload';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputSwitchModule } from 'primeng/inputswitch';
import { InputTextModule } from 'primeng/inputtext';
import { RippleModule } from 'primeng/ripple';
import { TableModule } from 'primeng/table';
import { TooltipModule } from 'primeng/tooltip';
import { PipesModule } from '../../../pipes/pipes.module';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient } from '@angular/common/http';
import { ToastrModule } from 'ngx-toastr';
import { MoreUsedComponent } from './more-used.component';
import { MoreUsedService } from './more-used.service';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, "assets/i18n/");
}

@NgModule({
    imports: [
        CommonModule,
        CardModule,
        GridsterModule,
        CalendarModule,
        InputNumberModule,
        InputSwitchModule,
        InputTextModule,
        RippleModule,
        TableModule,
        DropdownModule,
        CheckboxModule,
        TooltipModule,
        ChartModule,
        ReactiveFormsModule,
        FormsModule,
        FileUploadModule,
        PipesModule,
        TranslateModule,
        ToastrModule.forRoot({
            timeOut: 2500,
            enableHtml: true,
            positionClass: 'toast-top-right'
        }),
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            }
        }),
        MoreUsedComponent
    ],
    providers: [
        MoreUsedService
    ],
    exports: [
        MoreUsedComponent
    ],
})

export class MoreUsedModule {

}
